export default __webpack_public_path__ + "static/media/sofiaProRegularAz.d36998f5.otf";